import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {ToxicDigitsFixToEnglish} from "../../../components/techaran/money";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsStaffHireAddEditJobModal = (props: {
    active: boolean,
    closeHandler: any,
    id: string,
    edit: boolean,
    onDone: any,
}) => {
    const [title, setTitle] = useState('');
    const [certificate, setCertificate] = useState('');
    const [description, setDescription] = useState('');
    const [needed, setNeeded] = useState('');
    const ids = {
        title: useId(),
        certificate: useId(),
        description: useId(),
        needed: useId(),
    };
    const [err, setErr] = useState({
        title: false,
        certificate: false,
        description: false,
        needed: false,
    });
    const getData = (id:string) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/careers/job/get',
            {
                job:id,
            },
            true,
            (d: {
                result: string,
                reason: string,
                title:     string,
                cert:      string,
                desc:      string,
                needed:    number,
                isTaken:   boolean,
                createdAt: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setTitle(d.title);
                setDescription(d.desc);
                setCertificate(d.cert);
                setNeeded(d.needed.toString());
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.edit;
        const id = props.id;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            if(isEdit)
                getData(id);
            else {
                setTitle('');
                setDescription('');
                setCertificate('');
                setNeeded('');
            }
            setErr({
                title: false,
                certificate: false,
                description: false,
                needed: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const edit = props.edit;
        const data = {
            title: title.trim(),
            certificate: certificate.trim(),
            needed: needed.trim(),
            description: description.trim(),
            job: props.id.toString(),
        };
        let errors = {
            title: false,
            certificate: false,
            description: false,
            needed: false,
        };
        let stop = false;
        if (data.title.length < 2) {
            stop = true;
            errors.title = true;
        }
        if (data.certificate.length < 2) {
            stop = true;
            errors.certificate = true;
        }
        if (data.description.length < 2) {
            stop = true;
            errors.description = true;
        }
        if (data.needed === '') {
            stop = true;
            errors.needed = true;
        }
        setErr(errors);
        if (stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/careers/jobs/' + (edit ? 'edit' : 'add'),
            data,
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.onDone();
                props.closeHandler();
                ShowSnackbar(
                    edit ? 'فرصت شغلی ویرایش شد.' : 'فرصت شغلی جدید افزوده شد.',
                    'باشه',
                    5000,
                );
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش فرصت شغلی' : 'افزودن فرصت شغلی'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={ids.title} data-necessary="yes">عنوان شغل:</label>
                        <input type="text"
                               id={ids.title}
                               className={"form-control" + (err.title ? ' is-invalid' : '')}
                               value={title}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTitle(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.title = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.title ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.certificate} data-necessary="yes">مدرک تحصیلی:</label>
                        <input type="text"
                               id={ids.certificate}
                               className={"form-control" + (err.certificate ? ' is-invalid' : '')}
                               value={certificate}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setCertificate(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.certificate = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.certificate ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.description} data-necessary="yes">توضیحات و شرح وظایف:</label>
                        <textarea
                            style={{minHeight: 150, maxHeight: 300}}
                            id={ids.description}
                            className={"form-control" + (err.description ? ' is-invalid' : '')}
                            value={description}
                            onChange={e => {
                                const t = e.currentTarget.value;
                                setDescription(t);
                                setErr(v => {
                                    let x = {...v};
                                    x.description = false;
                                    return x;
                                });
                            }}
                        />
                        <div className={"invalid-feedback" + (err.description ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.needed} data-necessary="yes">ظرفیت (تعداد نفر):</label>
                        <input type="number"
                               min={1}
                               id={ids.needed}
                               className={"form-control" + (err.needed ? ' is-invalid' : '')}
                               value={needed}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setNeeded(ToxicDigitsFixToEnglish(t));
                                   setErr(v => {
                                       let x = {...v};
                                       x.needed = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.needed ? ' d-block' : ' d-none')}>لطفا یک عدد صحیح
                            وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <div className="d-flex justify-content-end align-items-center" style={{gap: 5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};